import InnerContainer from '@pages/EverGreen/Components/InnerContainer'
import React from 'react'
import { IInstructionSteps } from '../fast-payment'
import { css } from '@linaria/core'

function FPInstructionCards({content, titleColor, descriptionColor}:{content:IInstructionSteps, titleColor?:string, descriptionColor?:string}) {
  return (
    <InnerContainer className={containerStyle}>
        <h1 style={{color:titleColor}}>{content.title}</h1>
        <p style={{color:descriptionColor}}>{content.description}</p>
    </InnerContainer>
  )
}

const containerStyle = css`
    line-height: 25.2px;
    display: flex;
    flex-direction: column;
    gap:8px;
    border-radius: 16px;
h1{
    font-size: 18px;
    font-weight: 600;
    letter-spacing: calc(0.015*18px);
}
p{
    font-size: 14px;
    font-weight: 500;
}
`

export default FPInstructionCards